export default "__VITE_ASSET__CrAB9_h$__"